import { computeProduct } from '../../../../backend/src/utils/productFormula';
import type {
  ProductComputation,
  ProductSpec,
  ProductWorkbench,
  WorkbenchProduct,
} from '@/types/product';

export const money = (cents: number | null | undefined) =>
  cents == null
    ? 'Op aanvraag'
    : new Intl.NumberFormat('nl-NL', {
        style: 'currency',
        currency: 'EUR',
        minimumFractionDigits: cents % 100 ? 2 : 0,
        maximumFractionDigits: 2,
      }).format(cents / 100);
export const hours = (value: number) =>
  new Intl.NumberFormat('nl-NL', { maximumFractionDigits: 2 }).format(value);

export function rateName(rate: { key: string; name: string }): string {
  return /^€\s*[\d.,]+\s+per uur$/.test(rate.name) ? 'Algemeen tarief' : rate.name;
}

/** Keep invalid/unfinished input visible; it must never silently become a zero price. */
export function parseMoney(value: string): number | null {
  const cleaned = value.trim().replace(/\s/g, '').replace(/€/g, '');
  if (!/^\d+(?:[.,]\d{1,2})?$/.test(cleaned)) return null;
  const cents = Math.round(Number(cleaned.replace(',', '.')) * 100);
  return Number.isSafeInteger(cents) && cents <= 2147483647 ? cents : null;
}

export function calculate(
  spec: ProductSpec,
  rates: Record<string, number>,
  data: Pick<ProductWorkbench, 'componentPrices'>
): ProductComputation {
  return computeProduct(spec, rates, { componentPriceCents: data.componentPrices });
}

export function priceChanged(before: ProductComputation, after: ProductComputation): boolean {
  return after.variants.some(
    (variant) =>
      before.variants.find((item) => item.variantId === variant.variantId)?.priceCents !==
      variant.priceCents
  );
}

export function matchesProduct(
  product: WorkbenchProduct,
  spec: ProductSpec,
  query: string
): boolean {
  const text = [
    product.name,
    product.description,
    product.category,
    ...product.labels,
    ...spec.variants.map((variant) => variant.name),
    ...spec.lines.map((line) => line.description),
  ]
    .filter(Boolean)
    .join(' ');
  return text.toLocaleLowerCase('nl').includes(query.trim().toLocaleLowerCase('nl'));
}
